/** @typedef {(undefined | 'progress' | 'done')} SubscribeStatus */

export default class Footer {

  constructor() {
    this.switchInput = document.querySelector('.switch__input');
    this.switchName = document.querySelector('.switch__name');
    /** @type {HTMLFormElement} */
    this.subscribeForm = document.querySelector('.group-footer__form');
    /** @type {HTMLInputElement} */
    this.subscribeInput = this.subscribeForm.querySelector('.group-footer__input');
    /** @type {HTMLButtonElement} */
    this.subscribeSubmit = this.subscribeForm.querySelector('.group-footer__button');
    /** @type {HTMLDivElement} */
    this.subscribeResultText = this.subscribeForm.querySelector('.group-footer__result-text');
    /** @type {SubscribeStatus} */
    this.subscribeStatus = undefined;
  }

  _checkCheckbox(element) {
    return this.switchName.innerHTML = element.checked ? 'Выключить' : 'Включить';
  }

  init() {

    if (this.switchInput) {
      this.switchInput.addEventListener('click', e => this._checkCheckbox(e.target));
    }

    if (this.subscribeForm) {
      this.subscribeForm.addEventListener('submit', e => {
        e.preventDefault();
        if (this.subscribeStatus === undefined) {
          this.subscribeStatus = 'progress';
          this.subscribeSubmit.disabled = true;
          let email = this.subscribeInput.value;
          fetch('/admin/rest/subscribe/subscribe-default/', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 'email': email })
          })
            .then(r => r.json())
            .then(r => {
              this.subscribeStatus = 'done';
              this.subscribeSubmit.disabled = true;
              this.subscribeInput.disabled = true;

              this.subscribeResultText.innerText =
                r["errors"].length > 0
                  ? "Ваш адрес уже подписан на рассылку"
                  : "На ваш email отправлено сообщение. Для подтверждения подписки, перейдите по ссылке в письме"
                  ;
            });
        }
      });
    }

  }
}
